// Deutschland
export default {
	status: {
		All: "Alle",
		Pending: "Ausstehend",
		Frozen: "Eingefroren",
		Completed: "Abgeschlossen",
		Undone: "Ungemacht"
	},
	TotalAmount: "Gesamtbetrag",
	Profit: "Gewinn",
	Expire: "Abgelaufen"
};
